import { render, staticRenderFns } from "./MultipleChoiceUiComponent.vue?vue&type=template&id=74b204c0&scoped=true&"
import script from "./MultipleChoiceUiComponent.vue?vue&type=script&lang=ts&"
export * from "./MultipleChoiceUiComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MultipleChoiceUiComponent.vue?vue&type=style&index=0&id=74b204c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b204c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
